(() => {
  const initSliders = () => {
    const slideshows = document.querySelectorAll(".icon_with_text--slider-single");
    slideshows.forEach((slideshow) => {
      const autoplay =
        slideshow.getAttribute("data-autoplay") === "true" ? true : false;
      const slideshowSwiper = new Swiper(slideshow, {
        loop: false,
        autoHeight: false,
        allowTouchMove: true,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        slidesPerView: "auto",
        spaceBetween: 8,
        breakpoints: {
          320: {
            slidesPerView: "auto",
            spaceBetween: 8,
          },
          640: {
            slidesPerView: "auto",
            spaceBetween: 16,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: "auto",
            spaceBetween: 24,
          },
        },
      });
      if (autoplay) {
        slideshowSwiper.autoplay.run();
        slideshowSwiper.autoplay.running = true;

        slideshow.addEventListener("mouseenter", () => {
          slideshowSwiper.autoplay.pause();
        });
        slideshow.addEventListener("mouseleave", () => {
          slideshowSwiper.autoplay.run();
        });
      }
      if (slideshowSwiper.addSlide.length < 2) {
        slideshowSwiper.allowTouchMove = false;
      } else {
        slideshowSwiper.allowTouchMove = true;
      }
      if (slideshowSwiper.addSlide.length > 1)
        slideshow.classList.add("slideshow__swiper--multiple-slides");
    });
  };

  initSliders();

  document.addEventListener("shopify:section:load", function () {
    initSliders();
  });
})();
